const ProductLogo = () => <>🔭</>;

export default ProductLogo;
